import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { User } from '../../shared/models/User';
import { GlobalService } from '../../shared/services/global';
import { HttpService } from '../../shared/services/HttpService';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css']
})
export class ResetPasswordComponent implements OnInit {
  PasswordOne: string;
  PasswordTwo: string;
  UserToReset: User;
  hideLoadingModal: boolean;
  constructor(private http: HttpService, private global: GlobalService, private router: Router, private actRoute: ActivatedRoute) { }

  ngOnInit(): void {
    this.hideLoadingModal = true;
    this.PasswordOne = "";
    this.PasswordTwo = "";
    debugger;
    this.http.verifyUserReset(this.actRoute.snapshot.params.id).then(wrap => {
      if (wrap.StatusCode != "200") {
        //error occurred
        //navigate to home page
        //this.router.navigate(['./']);
        this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
          this.router.navigate(['./']));
      } else { this.UserToReset = <User>wrap.Content; }
    });
  }

  CreateNewPassword() {
    this.hideLoadingModal = false;
    if (this.PasswordOne == this.PasswordTwo && this.PasswordOne.length > 0) {
      //continue
      var currUser = this.UserToReset;
      currUser.Password = this.PasswordOne;
      this.http.ResetPassword(currUser).then(wrapper => {
        if (wrapper.StatusCode == "200") {
          //success, redirect to library
          this.router.navigate(['./dashboard']);
        } else {
          this.hideLoadingModal = true;
        }
      });
    }
    else {
      //stop
      this.hideLoadingModal = true;
    }
  }

  CancelResetPassword() {
    this.router.navigate(['./']);
  }

}
